<template>
  <div>
   <div class="homeExpert" v-if="$store.state.webNavigator=='pc'">
      <div class="home-expert marginAuto max1720">
        <div>
          <p class="part-title list-tlt displayIB" style="width: 100%">
            脂玫乐健康瘦身专家团
            <span class="list-tlt-tip">-</span>
          </p>
        </div>
        <div class="swiper-container banner2 home-expert-rol positionRE">
          <div class="swiper-wrapper">
            <div class="swiper-slide positionRE" v-for="(item,index) in $store.state.home.getDotor" :key="index">
              <div class="displayIB">
                <img class="home-expert-doctorimg" :src="httptype(item.img)" alt="">
              </div>
              <div class="home-expert-doctorText displayIB">
                <p class="font36px">{{item.name}} <span class="displayIB home-expert-hr"></span></p>
                <p class="col666666 home-expert-doctorTlt">{{item.education}}</p>
                <p class="home-expert-doctor-intro">{{item.content}}</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="swiper-container banner5 expert-all-doctorlist displayIB positionRE">
            <div class="swiper-wrapper">
              <div class="expert-doctorlist swiper-slide pointEr"
                   v-for="(item , index) in $store.state.home.getDotor"
                   :key="index"
                   @mousemove="moveChange(index,'true')"
                   @mouseleave="moveChange(index,'false')"
              >
                <div class="displayIB">
                  <img class="expert-doctorlist-img" :src="httptype(item.img)"
                       alt="" title="">
                </div>
                <div v-if="activeIndex === index || activeIndex2 === index" class="expert-doctorlist-name positionAB colffffff">{{item.name}}</div>
              </div>
            </div>
            <div class="min-next pointEr positionAB"></div>
            <div class="min-prev pointEr positionAB"></div>
          </div>
        </div>
      </div>
    </div>
   <div class="phone-page" v-else>
      <div class="PhoneHome-title">
        脂玫乐健康瘦身专家团 <span class="col00CDA2">-</span>
      </div>
      <div>
        <div class="swiper-container bannerEx home-team-bar home-rol">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in $store.state.home.getDotor" :key="index">
              <div class="PhoneExpert-Box">
                <img class="PhoneExpert-img" :src="httptype(item.img)" alt="3大保障·脂玫乐健康瘦身值得您托付" title=""/>
                <div class="PhoneExpert-TextBox">
                  <div class="PhoneExpert-Name col33333 font40phone">
                    {{item.name}}<span class="PhoneExpert-Tip font36phone">{{' - '+item.education}}</span>
                  </div>
                  <div class="PhoneExpert-introduce">
                    {{item.content}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {myFun} from "../../../../plug/modifyImagePath"
export default {
  name: 'homeExpert',
  props: {
    loadType: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      activeIndex: '',
      activeIndex2: '',
      imgUrl: 'https://jusexcx.zmelo.com/',
      detailShowStatus: false, // 医生详情弹出层
      selectedDoctor: {
        name: '',
        education: '',
        img: '',
        content: '',
      }, // 当前选中的医生
    };
  },
  methods: {
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return myFun(url);
        }
      }
      return '';
    },
    showDetail (item) {
      this.selectedDoctor = item;
      this.changeDetailAlertStatus();
    }, // 显示医生详情弹框
    changeDetailAlertStatus () {
      this.detailShowStatus = !this.detailShowStatus;
    }, // 关闭弹窗
    initSwiper2 () {
      let that = this;
      this.$store.dispatch('getSwiper', () => {
        // 广告轮播图
        this.banner2 = new Swiper('.banner2', {
          spaceBetween: 10,
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          on: {
            slideChangeTransitionEnd: function () {
              if (that.activeIndex !== this.realIndex) {
                that.activeIndex = this.realIndex;
              }
            },
          },
          thumbs: {
            swiper: {
              el: '.banner5',
              spaceBetween: 10,
              slidesPerView: 7,
              watchSlidesVisibility: true,
              navigation: {
                nextEl: '.min-next',
                prevEl: '.min-prev',
              },
            },
          },
        });
      });
    },
    initSwiperEx () {
      this.$store.dispatch('getSwiper', () => {
        // 广告轮播图
        this.bannerEx = new Swiper('.bannerEx', {
          loop: true,
          autoHeight: true,
          autoplay: true,
        });
      });
    },
    moveChange (index, type) {
      if (type == 'true') {
        this.activeIndex2 = index;
      } else {
        this.activeIndex2 = '';
      }
    },
  },
  mounted () {
    this.$store.state.webNavigator == 'pc' ? this.initSwiper2() : this.initSwiperEx();
  },
};
</script>

<style lang="less" scoped>
  @import url('../../../../../static/css/fontSize.less');
  @media screen and (max-width: 800px) {
    .phone-page{
      padding: 113*@width1 0 0;
      background: #fff;
    }
    .PhoneHome-title{
      margin-bottom: 39*@width1;
    }
    .PhoneExpert-Box{
      width: 690*@width1;
    }
    .PhoneExpert-img{
      width: 690*@width1;
      height: 357*@width1;
      vertical-align: top;
    }
    //文字板块
    .PhoneExpert-TextBox{
      width:690*@width1;
      padding: 43*@width1 29*@width1 41*@width1;
      background:rgba(0,205,162,0.1);
    }
    .PhoneExpert-introduce{
      color: #666666;
      margin-top: 28*@width1;
      font-size: 24*@width1;
      line-height:34*@width1;
    }
  }
  @media screen and (min-width: 800px) {
    .homeExpert{
      margin: 50*@width;
      margin-top: 2.208vw;
      margin-bottom: 0;
      padding-bottom: 50*@width;
    }
    .home-expert-rol{
      margin-top: 15*@width;
    }
    .home-expert-doctorimg{
      width:487*@width;
      height:252.5*@width;
    }
    .home-expert-doctorText{
      width: 190*@width;
      vertical-align: top;
      margin-left: 11.5*@width;
    }
    .home-expert-hr{
      width:30.15*@width;
      height:1px;
      background:#26D4B0;
      vertical-align: middle;
      margin-left: 14*@width;
    }
    .home-expert-doctor-name{
      font-size: 20*@width;
    }
    .home-expert-doctorTlt{
      font-size: 11*@width;
      margin: 10*@width 0;
    }
    .home-expert-doctor-intro{
      color: #666;
      font-size: 8*@width;
      line-height: 13*@width;
      max-height: 170*@width;
    }
    .min-next,.min-prev{
      display: none;
    }
    .expert-all-doctorlist:hover .min-next,
    .expert-all-doctorlist:hover .min-prev{
      display: inline-block;
    }
    .min-next{
      right: 5*@width;
      background: url("https://jusewebapp.zmelo.com/zml-gw/pc_home/minnext.png") no-repeat;
    }
    .min-next,.min-prev{
      z-index: 99;
      width: 12.2*@width!important;
      height: 12.2*@width!important;
      background-size: 12.2*@width!important;
      top: 18*@width;
    }
    .min-prev{
      left: 5*@width;
      background: url("https://jusewebapp.zmelo.com/zml-gw/pc_home/minprev.png") no-repeat;
    }
    .expert-doctorlist{
      margin-right: 5*@width;
    }
    .expert-doctorlist-img,.expert-doctorlist,.expert-doctorlist-name{
      width:96*@width;
      height:47*@width;
    }
    .expert-doctorlist-name{
      font-size: 8*@width;
      text-align: center;
      line-height: 50*@width;
      top: 0;
      background:#26D4B0;
      opacity:0.85;
      z-index: 99;
    }
    //.expert-doctorlist:hover .expert-doctorlist-name{
    //  display: inline-block;
    //}
    .home-expert-more-icon{
      width: 15*@width;
      height: 15*@width;
      bottom: 54.5*@width;
      right: 0;
    }
    .expert-all-doctorlist{
      margin-top: 5*@width;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// homeExpert.vue